import './WarResultModal.css'
import { useGameContext } from '../../GameContext'

const CONTENT = {
    win: {
        headline: 'Victory',
        subtext: "The enemy didn't stand a chance.",
        iconSrc: '/Win_flag_SVG.svg',
        iconAlt: 'Win flag',
    },
    loss: {
        headline: 'Loss',
        subtext: 'Until next time...',
        iconSrc: '/Loss_Flag_SVG.svg',
        iconAlt: 'Loss flag',
    },
    draw: {
        headline: 'Draw',
        subtext: 'Until next time...',
        iconSrc: '/Draw_Flag_SVG.svg',
        iconAlt: 'Draw flag',
    },
}

// onMainMenu replaces the lobby's leaveRoom (the progression prototype's wars).
export default function WarResultModal({ result, onMainMenu }) {
    const { headline, subtext, iconSrc, iconAlt } = CONTENT[result] ?? CONTENT.draw
    const { leaveRoom } = useGameContext()

    function handleNewWar() {
        if (onMainMenu) onMainMenu()
        else leaveRoom()
    }

    return (
        <div className={`wrm__overlay wrm__overlay--${result}`}>
            <div className="wrm__card">

                <div className="wrm__icon-slot">
                    <img src={iconSrc} alt={iconAlt} className="wrm__icon-img" />
                </div>

                <h1 className="wrm__headline">{headline}</h1>

                {subtext && (
                    <p className="wrm__subtext">{subtext}</p>
                )}

                <button className="wrm__cta" onClick={handleNewWar}>
                    <span className="wrm__cta-main">Main Menu</span>
                </button>

            </div>
        </div>
    )
}
